/**
 * The message to show when one of the four approval endpoints refuses an action.
 *
 * Three shapes reach here and only one of them carries `error`:
 *  - 422 validation ({message, errors}) — `comments` is the only field these
 *    endpoints reject on, and reading `data.error` yields undefined.
 *  - 409 APPROVAL_NOT_PENDING and 403 APPROVAL_NOT_AN_APPROVER ({error,
 *    error_code}) — the approval refusals.
 *  - anything else, which falls back to the caller's own wording.
 */
export const approvalActionErrorMessage = (e, fallback) => {
    const data = e?.response?.data;

    // `message` is read ONLY on a 422. Outside validation it is Laravel's own
    // wording — the raw exception text in debug mode, or an untranslated
    // "This action is unauthorized." — neither of which should reach a user.
    const validationMessage = e?.response?.status === 422 ? data?.errors?.comments?.[0] || data?.message : undefined;

    return validationMessage || data?.error || fallback;
};

export const setUploadErrors = (e, errorKey, fieldName, actions, formik = true) => {
    if (e?.response?.data?.errors) {
        Object.keys(e?.response?.data?.errors).forEach((key) => {
            if (key === errorKey) {
                if (formik) {
                    actions.setFieldError(fieldName, e.response.data.errors[key][0]);
                } else {
                    actions(e.response.data.errors[key]);
                }
            }
        });
    }
};
